import React from 'react'
import { Form } from 'semantic-ui-react'

import { EmailInput } from 'components/EmailInput'
import ErrorText from 'shared/components/forms/ErrorText'

/**
 *
 * @param {object} props
 * @param {string=} props.value
 * @param {(e) => void} props.onChange
 * @param {string=} props.error
 */
export default function InviteUserEmailInput({ onChange, value, error }) {
  return (
    <Form.Field error={Boolean(error)}>
      <label>Email Address</label>
      <EmailInput onChange={onChange} value={value} />
      <ErrorText>{error}</ErrorText>
    </Form.Field>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/InviteUserEmailInput/index.js